import Vue from 'vue'
import moment from 'moment'

/*
var price = 10000
{{ price | number }} = 10,000
*/
Vue.filter('number', function (value) {
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
})
Vue.filter('gbp', function (value) {
  if (value === null) {
    return null
  }
  return (value < 0 ? '-' : '') + '£' + Math.abs(value).toFixed(2).replace(/\B(?=(\d{3})+(?!\d)\.\d\d)/g, ',')
})

Vue.filter('datetime', function (date, convert = true) {
  if (!convert) {
    return moment(date).format('DD/MM/YYYY HH:mm')
  }

  return moment.utc(date).local().format('DD/MM/YYYY HH:mm')
})
Vue.filter('verboseDate', function (date, convert = true) {
  if (!convert) {
    return moment(date).format('dddd, Do MMMM YYYY')
  }

  return moment.utc(date).local().format('dddd, Do MMMM YYYY')
})
Vue.filter('date', function (date, convert = true) {
  if (!convert) {
    return moment(date).format('DD/MM/YYYY')
  }

  return moment.utc(date).local().format('DD/MM/YYYY')
})
Vue.filter('month', function (month) {
  if (month === null) {
    return ''
  }

  const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
  return months[month - 1]
})
Vue.filter('year', function (date, convert = true) {
  if (!convert) {
    return moment(date).format('YYYY')
  }

  return moment.utc(date).local().format('YYYY')
})
Vue.filter('time', function (date, convert = true) {
  if (!convert) {
    return moment(date).format('HH:mm')
  }

  return moment.utc(date).local().format('HH:mm')
})
Vue.filter('time12hr', function (date, convert = true) {
  if (!convert) {
    return moment(date).format('h:mma')
  }

  return moment.utc(date).local().format('h:mma')
})
Vue.filter('countryName', function (countryCode) {
  switch (countryCode.toUpperCase()) {
    case 'GB': return 'United Kingdom'
    case 'AU': return 'Australia'
    case 'BB': return 'Barbados'
    case 'FR': return 'France'
    case 'DE': return 'Germany'
    case 'HU': return 'Hungary'
    case 'IE': return 'Ireland'
    case 'JE': return 'Jersey'
    case 'MU': return 'Mauritius'
    case 'NA': return 'Namibia'
    case 'PT': return 'Portugal'
    case 'ZA': return 'South Africa'
    case 'ES': return 'Spain'
    case 'CH': return 'Switzerland'
    case 'TH': return 'Thailand'
    case 'AE' : return 'UAE'
    case 'ZW': return 'Zimbabwe'
  }
})
Vue.filter('dayName', function (date, convert = true) {
  if (!convert) {
    return moment(date).format('dddd')
  }

  return moment.utc(date).local().format('dddd')
})
Vue.filter('dayShortName', function (date, convert = true) {
  if (!convert) {
    return moment(date).format('ddd')
  }

  return moment.utc(date).local().format('ddd')
})
Vue.filter('completedUrl', function (url) {
  return url.startsWith('http') ? url : 'https://' + url
})
Vue.filter('sizeInMb', function (value) {
  return (value / (1024 * 1024)).toFixed(2)
})
